let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3X7oq")).then(() => parcelRequire('6G1GD'));